import React, { Component } from 'react';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import {IS_GROUP} from 'components/mix/constants.js';
import {IS_TRACK} from 'components/mix/constants.js';
import {IS_SEND} from 'components/mix/constants.js';
import {setSelectedGroup} from 'actions/index.js';
import {setSelectedTrack} from 'actions/index.js';
import {setMultiParameterSliderValue} from 'actions/index.js';
import { connect } from "react-redux";
import {setParametersToRecord} from 'actions/index.js';

class MultiParameterSlider extends Component {
    constructor(props) {
        super(props);

        this.state = {
            // put this value in redux so you don't have to keep checking
            minSelected: false,
            maxSelected: false,
            isMouseDown: false,
        };
    }

    onMouseDown() {
    }

    onMouseUp() {
        this.props.setParametersToRecord([]);
    }

    getEffectsTrackIf(type) {
        let sends = this.props.sequencerEngine.sends.sends;
        if (type === IS_TRACK) {
            return this.props.selectedTrack;
        } else if (
            type == IS_GROUP &&
                sends.indexOf(this.props.selectedGroup) == -1) {
            return this.props.selectedGroup;
        }  else if (type == IS_SEND &&
                    sends.indexOf(this.props.selectedGroup) > -1) {
            return this.props.selectedGroup;
        }
        return undefined;
    }

    getParameterLocks() {
        if (this.props.sequencerEngine.parameterLocks[this.props.id] === undefined) {
            return [];
        }
        return this.props.sequencerEngine.parameterLocks[this.props.id].parameterLocks;
    }

    onChange(val) {
        if (this.state.minSelected) {
            if (this.state.selectedParameter !== undefined) {
                this.state.selectedParameter.min = this.state.selectedParameter.normalizeOriginal(val);
                this.state.selectedParameter.set(this.state.selectedParameter.min);
                this.props.setMultiParameterSliderValue(this.props.id, val);
            }
        } else if (this.state.maxSelected) {
            if (this.state.selectedParameter !== undefined) {
                this.state.selectedParameter.max  = this.state.selectedParameter.normalizeOriginal(val);
                this.state.selectedParameter.set(this.state.selectedParameter.max);
                this.props.setMultiParameterSliderValue(this.props.id, val);
            }
        } else {
            // actually alter the parameter with the set min/max defining
            let parameters = this.getParameterLocks().map(parameterLock => parameterLock.parameter);
            parameters.forEach(param => param.normalizedSet(val));
            this.props.setMultiParameterSliderValue(this.props.id, val);
            this.props.setParametersToRecord(parameters);
        }
    }

    onAdd() {
        if (this.props.selectedParameter !== undefined) {
            // get group number and track number
            let groupNumber = this.getEffectsTrackIf(IS_GROUP) !== undefined ?
                this.getEffectsTrackIf(IS_GROUP).groupNumber : undefined;
            let trackNumber = this.getEffectsTrackIf(IS_TRACK) !== undefined ?
                this.getEffectsTrackIf(IS_TRACK).trackNumber  : undefined;
            let sendNumber = this.getEffectsTrackIf(IS_SEND) !== undefined ?
                this.getEffectsTrackIf(IS_SEND).sendNumber : undefined;
            let effectNumber = this.props.selectedEffect;
            this.props.sequencerEngine.parameterLocks[this.props.id].addParameterLock(
                trackNumber,
                groupNumber,
                sendNumber,
                effectNumber,
                this.props.selectedParameter);
            this.setState(this.state);
        }
    }

    onDeleteParameterLock(parameterLock) {
        this.props.sequencerEngine.parameterLocks[this.props.id].deleteParameterLock(
            parameterLock);
    }

    onClickParameterLock(parameterLock) {
        if (this.state.selectedParameter === parameterLock.parameter) {
            this.setState({selectedParameter: undefined});
        } else {
            if (parameterLock.trackNumber !== undefined) {
                let track =this.props.sequencerEngine.tracks[parameterLock.trackNumber];
                this.props.setSelectedTrack(track.trackNumber)
                this.props.setSelectedGroup(undefined);
            } else if (parameterLock.groupNumber !== undefined) {
                this.props.setSelectedTrack(undefined);
                this.props.setSelectedGroup(this.props.sequencerEngine.groups.groups[parameterLock.groupNumber]);
            } else if (parameterLock.sendNumber !== undefined) {
                let send = this.props.sequencerEngine.sends.sends[parameterLock.sendNumber];
                this.props.setSelectedTrack(undefined);
                this.props.setSelectedGroup(send);
            }
            this.setState({selectedParameter: parameterLock.parameter});
        }
    }

    onClickMin() {
        this.setState({minSelected: !this.state.minSelected, maxSelected: false});
    }

    onClickMax() {
        this.setState({maxSelected: !this.state.maxSelected, minSelected: false});
    }

    formatNumber(n) {
        if (n <= 1) {
            return n;
        } else {
            return Math.floor(n);
        }
    }

    render() {
        return (
            <div
              onMouseDown={() => this.onMouseDown()}
              onMouseLeave={() => this.onMouseUp()}
              onMouseUp={() => this.onMouseUp()}
              className="multi-parameter-slider-container">
              <div className="ranged-slider-container">
                <div
                  onClick={() => this.onClickMin()}
                  className={this.state.minSelected ? "selected min-label" : "min-label"}>
                  {this.state.selectedParameter !== undefined ? this.formatNumber(this.state.selectedParameter.min) : 'MIN'}
              </div>
              <div className="slider-container">
                <ReactBootstrapSlider
                  handle="square"
                  value={this.props.value}
                  change={(e) => this.onChange(e.target.value)}
                  step={0.01}
                  max={1}
                  min={0}
                  orientation="horizontal"
                  reversed={false}/>
              </div>
              <div
                onClick={() => this.onClickMax()}
                className={this.state.maxSelected ? "selected max-label" : "max-label"}>
                {this.state.selectedParameter !== undefined ? this.formatNumber(this.state.selectedParameter.max) : 'MAX'}
              </div>
              </div>
              <div className="parameters-container">
                <div className="parameters-title">PARAMETERS</div>
                <div
                  onClick={() => this.onAdd()}
                  className={this.props.flashing !== undefined ? "flashit add-parameter-button" : "add-parameter-button"}>
                  +
                </div>
              <div className="parameters-list">
                {this.getParameterLocks().map(parameterLock =>
                  <ParameterElement
                    onDelete={() => this.onDeleteParameterLock(parameterLock)}
                    onClick={() => this.onClickParameterLock(parameterLock)}
                    isSelected={this.state.selectedParameter === parameterLock.parameter}
                    parameter={parameterLock.parameter}/>)}
              </div>
            </div>
          </div>);
            
    }
}

class ParameterElement extends Component {
    render() {
        return (
            <div className={this.props.isSelected ? "selected parameter-lock" : "parameter-lock"} onClick={this.props.onClick}>
              {this.props.parameter.effectName !== undefined ?
                  <div>
                    {this.props.parameter.effectName} - {this.props.parameter.name}
                        <div className="delete-button" onClick={this.props.onDelete}>x</div>
                  </div>
                      :
                  <div>
                     {this.props.parameter.name}
                         <div className="delete-button" onClick={this.props.onDelete}>x</div>
                  </div>}
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSelectedTrack: track => dispatch(setSelectedTrack(track)),
        setSelectedGroup: group => dispatch(setSelectedGroup(group)),
        setParametersToRecord: params => dispatch(setParametersToRecord(params)),
        setMultiParameterSliderValue: (id, value) => dispatch(setMultiParameterSliderValue(id, value))
    }
};

const mapStateToProps = (state, props) => {
    return {
        selectedParameter: state.mix.selectedParameter,
        flashing: state.mix.selectedParameterFlashing,
        selectedEffect: state.effects.selectedEffect,
        selectedTrack: state.mix.selectedTrack,
        selectedGroup: state.mix.selectedGroup,
        value: state.mix.multiParameterSliderValues[props.id] || 0,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MultiParameterSlider);


